/**
 * The plan inside the run card: what will be looked at, and where from.
 * Replaces the separate plan and "Updated the plan" chat messages.
 */
import { el } from '../../core/dom.js';

const SOURCE_NAMES = {
  store: 'synced data',
  revenuecat: 'RevenueCat',
  appfigures: 'AppFigures',
  'amazon-reports': 'Amazon Appstore',
  amazon_iap: 'Amazon Appstore',
  github: 'GitHub',
  firebase: 'Firebase',
  mixpanel: 'Mixpanel',
  posthog: 'PostHog',
  'app-store-connect': 'App Store Connect',
  'google-play': 'Google Play',
  'google-analytics': 'Google Analytics',
  appsflyer: 'AppsFlyer',
  stripe: 'Stripe',
  knowledge: 'knowledge base',
};

export function sourceName(id) {
  const key = String(id || '').trim();
  if (!key) return '';
  if (SOURCE_NAMES[key]) return SOURCE_NAMES[key];
  return key.replace(/[-_]+/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}

/**
 * @param {unknown} plan
 * @returns {object|null}
 */
export function parsePlan(plan) {
  let p = plan;
  if (typeof p === 'string') {
    try { p = JSON.parse(p); } catch { return null; }
  }
  return p && typeof p === 'object' && Array.isArray(p.questions) && p.questions.length ? p : null;
}

/**
 * @param {unknown} stageState
 * @returns {number}
 */
export function planVersionOf(stageState) {
  let s = stageState;
  if (typeof s === 'string') {
    try { s = JSON.parse(s); } catch { s = null; }
  }
  const v = s && Number(s.planVersion);
  return Number.isFinite(v) && v > 0 ? v : 0;
}

/**
 * @param {object} run
 * @returns {HTMLElement|null}
 */
export function renderPlan(run) {
  const plan = parsePlan(run && run.plan);
  if (!plan) return null;
  const updated = planVersionOf(run.stage_state) > 1;
  const list = el('ol', { class: 'chat-run-plan-list' }, plan.questions.map((q) => {
    const names = [...new Set((q.sources || []).map(sourceName).filter(Boolean))];
    return el('li', {},
      String(q.text || q.id || '').trim(),
      names.length ? el('span', { class: 'chat-run-plan-from' }, ` — ${names.join(', ')}`) : null);
  }));
  return el('div', { class: 'chat-run-plan' },
    el('p', { class: 'chat-run-plan-title' }, updated ? 'Plan (updated with your instruction)' : 'Plan'),
    list);
}
